var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxNewWindow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.992 4.005a1 1 0 01.117 1.991l-.117.007H6.994a1 1 0 00-.993.882l-.006.117v9.99a1 1 0 00.883.993l.116.006h9.997a1 1 0 00.993-.882l.006-.117v-4.995a1 1 0 011.993-.116l.007.116v4.995a2.998 2.998 0 01-2.823 2.992l-.176.006H6.994A2.998 2.998 0 014 17.169l-.005-.177v-9.99c0-1.596 1.249-2.901 2.823-2.992l.176-.005h4.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.996 8.002a1 1 0 01-1-1V5.414l-5.557 5.588A1.018 1.018 0 1113 9.562l5.589-5.557h-1.589a1 1 0 110-2h3.997a1 1 0 01.38.08 1 1 0 01.54.54 1 1 0 01.08.38v3.997a1 1 0 01-1 1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxNewWindow);
export default __webpack_public_path__ + "static/media/4-icon-24-px-new-window.8e13a1f9.svg";
export { ForwardRef as ReactComponent };